<template>
    <Row
         :is-form-row="isFormRow"
         :is-margin-top="isRowMarginTop"
    >
        <Column
                :xs-display="xsDisplay"
                :sm-display="smDisplay"
                :md-display="mdDisplay"
                :lg-display="lgDisplay"
                :xl-display="xlDisplay"

                :xs-size="xsSize"
                :sm-size="smSize"
                :md-size="mdSize"
                :lg-size="lgSize"
                :xl-size="xlSize"

                :no-margin-top="noColumnMarginTop"
        >
            <slot></slot>
        </Column>
    </Row>
</template>

<script>
    import Column from "./html/Column";
    import Row from "./html/Row";
    import sizeClassesMixin from "./html/mixin/sizeClassesMixin";
    import displayClassesMixin from "./html/mixin/displayClassesMixin";

    export default {
        name: "RowColumn",
        mixins: [sizeClassesMixin, displayClassesMixin],
        components: {Row, Column},
        props: {
            type: {
                type: String,
                default: 'row',
                validator: (value) => ['row', 'form-row', 'container', 'container-fluid', 'none'].indexOf(value) !== -1,
            },
            isFormRow: {
                type: Boolean,
                default: false,
            },
            isRowMarginTop: {
                type: Boolean,
                default: false,
            },

            noColumnMarginTop: {
                type: Boolean,
                default: false
            },
        }
    }
</script>

<style scoped>

</style>